import PropTypesPresenter from '../utils/PropTypesPresenter';

export default new PropTypesPresenter(
  {},
  {
    formatDollarAmount(amount) {
      const formattedAmount = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        currencyDisplay: 'narrowSymbol',
      }).format(amount);

      return formattedAmount;
    },
  }
);
